jQuery(function() {
    if ( jQuery('.upcoming-news-block__news').length ) {
        jQuery('.upcoming-news-block__news').first().addClass('upcoming-news-block__news-first');
        jQuery('.upcoming-news-block__news').last().addClass('upcoming-news-block__news-last');
    }
});